import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";

export const injected = new InjectedConnector({ supportedChainIds: [137] });

export const walletConnect = new WalletConnectConnector({
  rpc: { 1: "https://polygon-rpc.com" },
  qrcode: true,
});
